import Alert from '@r1-frontend/ui-react/components/Alert';
import Button from '@r1-frontend/ui-react/components/buttons/button';
import { ButtonGroup } from '@r1-frontend/ui-react/components/buttons/buttonGroup/ButtonGroup';
import { H3 } from '@r1-frontend/ui-react/components/typography/heading';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import TextWrapper from '@r1-frontend/ui-react/components/typography/TextWrapper';
import { FullWidthListContainer } from '@r1-frontend/ui-react/experimental/containers';
import SteppableProgressBar from '@r1-frontend/ui-react/organisms/SteppableProgressBar';

import { speedBonusConnectionAnalytics } from '~/src/entities/speed-bonus/analytics';
import { flushState } from '~/src/entities/speed-bonus/context/actions';
import { activate } from '~/src/entities/speed-bonus/context/actions/thunk';
import { useContextDispatch, useContextSelector } from '~/src/entities/speed-bonus/context/hooks';
import { routerSelectionButtonText, selectedRouter, selectRouters } from '~/src/entities/speed-bonus/context/selectors';

import HowToChooseRouter from './components/HowToChooseRouter';
import RoutersList from './containers/RoutersList';

const RoutersPage = (): JSX.Element => {
    const dispatch = useContextDispatch();

    const { isLoading, router, routers, buttonText } = useContextSelector(state => ({
        isLoading: state.isLoading,
        router: selectedRouter(state),
        routers: selectRouters(state),
        buttonText: routerSelectionButtonText(state),
    }));

    const activateHandler = () => {
        speedBonusConnectionAnalytics.routerSelection(router);

        dispatch(activate());
    };

    const goBackHandler = () => {
        dispatch(flushState());
    };

    return (
        <FullWidthListContainer $size={32} $direction={'column'}>
            <FullWidthListContainer $size={24} $direction={'column'}>
                <SteppableProgressBar
                    progress={1 / 2}
                    title={'Назад'}
                    onClick={goBackHandler}
                />
                {routers.length
                    ? <>
                        <Alert type={'info'}>
                            <Paragraph4>
                                Рекомендуем обновить роутер&nbsp;&mdash; возможно он&nbsp;не&nbsp;будет поддерживать скорость вашего тарифа с&nbsp;бонусом.
                                Поэтому после подключения скорость интернета не&nbsp;изменится.
                            </Paragraph4>
                        </Alert>

                        <TextWrapper $lastIndent={false}>
                            <H3>Рекомендуем выбрать роутер</H3>
                            <Paragraph4>Предложенные роутеры оптимально подходят для вашего тарифа. <HowToChooseRouter/></Paragraph4>
                        </TextWrapper>

                        <RoutersList/>
                    </>
                    : <Alert type={'info'}>
                        <Paragraph4>
                            Для подключения новой скорости понадобится визит инженера.
                            Он&nbsp;заменит кабель в&nbsp;квартире или оборудование в&nbsp;подъезде. Деньги за&nbsp;скоростной бонус спишем, когда всё будет готово.
                        </Paragraph4>
                    </Alert>
                }
            </FullWidthListContainer>

            <ButtonGroup>
                <Button
                    size={'large'}
                    bType={'action'}
                    onClick={activateHandler}
                    loading={isLoading}
                    disabled={isLoading}
                >
                    {buttonText}
                </Button>
            </ButtonGroup>
        </FullWidthListContainer>
    );
};

export default RoutersPage;
